import L from 'leaflet';
import { isEmpty } from 'lodash';
import { iconRPAOptions } from '../client/waypoint-style-chooser';

/**
 * Draws the current RPA Position with bearing in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.rpaBearing - The mission object.
 * @param {?object} arg.RPAPostionLayer - The geoJSON layer where the take off point will be painted.
 * @param {Function} arg.currentRPAPosition - A function that gets the current variables needed from the map component.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet layers where the RPA Position with bearing is painted.
 */
const drawRPAPosition = ({
  currentRPAPosition,
  rpaBearing,
  leafletMap,
  RPAPositionLayer,
  isUpdate = false
}) => {
  let newRPAPositionLayerContainer = '';
  if (!isUpdate) {
    newRPAPositionLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newRPAPositionLayerContainer = RPAPositionLayer;
    newRPAPositionLayerContainer.clearLayers();
  }
  if (!isEmpty(currentRPAPosition)) {
    const myRPAPointLayer = L.geoJSON(currentRPAPosition, iconRPAOptions(rpaBearing));
    newRPAPositionLayerContainer.addLayer(myRPAPointLayer.getLayers()[0]);
  }
  return newRPAPositionLayerContainer;
};
export default drawRPAPosition;
